import React from 'react';
import './index.scss';

import Theme1 from './Theme1';
import Theme2 from './Theme2';
import Theme3 from './Theme3';
import FFTheme1 from './FFTheme1';

const Themes = {
	Theme1,
	Theme2,
	Theme3,
	FFTheme1,
};

const WelcomeScreen = (props) => {
	const Component = Themes[props.theme];

	return (
		<React.Suspense fallback={<div>Loading...</div>}>
			{props.theme &&
			props.theme.length > 0 &&
			props.theme.toLowerCase() != 'default' ? (
				<Component {...props} />
			) : null}
		</React.Suspense>
	);
};

export default WelcomeScreen;
